import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'
import TeacherInfoDock from 'template/Docks/TeacherInfo';
import Teacher from 'mediators/Teacher';
import PhotoViewer from 'template/Modals/Photo';
import __R, { userCan } from 'containers/__R'

const MALE_USER_PORTRAIT = require('data/images/male-user-icon.png')
const FEMALE_USER_PORTRAIT = require('data/images/female-user-icon.png')
const NEUTRAL_IMG = require('data/images/default-logo.png');

class TeacherNameTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    teacher: PropTypes.object.isRequired
  }

  viewPhoto(image) {
    if (!image) {
      return;
    }

    PhotoViewer({ photo: image });
  }
  render(){
    const {teacher} = this.props
    const {id, tName} = teacher

    // 0 = male, 1 = female
    const hasPhoto = teacher.profile_photo_thumbnail_8x != '';
    let image;
    if (teacher.profile_photo_thumbnail_2x) {
      image = `url(${teacher.profile_photo_thumbnail_2x})`;
    }else {
      if (teacher.tGender == 0){
        image = `url(${MALE_USER_PORTRAIT})`
      } else if(teacher.tGender == 1) {
        image = `url(${FEMALE_USER_PORTRAIT})`
      } else {
        image = `url(${NEUTRAL_IMG})`
      }
    }
    return(
      <div className='teacher-name'>
        <div className={classnames("portrait", { hasPhoto })} style={{
					backgroundImage: image
        }} onClick={()=>{
          if(hasPhoto) {
            this.viewPhoto(teacher.profile_photo_thumbnail_8x)
          }
        }
        }>
				</div>
        <__R can="read_teacher_detail" by='disable'>
          <button className='btn-link' onClick={() => {
            TeacherInfoDock({id, name: tName})
          }}>{teacher.tName}</button>
        </__R>

      </div>
    )
  }
}


export default (TeacherNameTd)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/TeacherTable/TeacherNameTd.js